import {useEffect, useState} from 'react';
import {workoutStore} from '../components/app/WorkoutSequence';
import {useStore} from '../store/useStore';

/**
 * Hook to handle exercise time remaining display
 * This provides a consistent mechanism for all exercises to display the time remaining
 * and respect the paused state of the workout
 */
export const useExerciseTime = () => {
  const [timeRemaining, setTimeRemaining] = useState(0);
  const isTimerPaused = useStore(state => state.isTimerPaused);

  // Initialize time and set up refresh interval
  useEffect(() => {
    // Get initial time
    if (!isTimerPaused) {
      setTimeRemaining(workoutStore.getTimeRemaining());
    }

    // Set up refresh interval
    // Set up refresh interval - we'll check for changes regularly
    // but only update our state if we're not paused and the value has changed
    const refreshTimer = setInterval(() => {
      const currentValue = workoutStore.getTimeRemaining();

      // Only update time if not paused
      if (!workoutStore.isPaused() && currentValue !== timeRemaining) {
        setTimeRemaining(currentValue);
      }
    }, 250);

    return () => clearInterval(refreshTimer);
  }, [timeRemaining]);

  return timeRemaining;
};
